import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReceiptDeleteDialog = ({ receipt, onClose, onDeleted }) => {
  const [busy, setBusy] = useState(false);

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.delete(`${API}/admin/receipts/${receipt.id}`);
      toast.success('Receipt deleted');
      onDeleted(receipt.id);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to delete receipt');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AlertDialog open={!!receipt} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="receipt-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this receipt?</AlertDialogTitle>
          <AlertDialogDescription>
            {receipt?.category} · £{Number(receipt?.amount || 0).toFixed(2)}{receipt?.note ? ` · ${receipt.note}` : ''}.
            This can't be undone. {receipt?.bookingId ? `The deletion will be recorded in the job log for ${receipt.bookingId}.` : ''}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="receipt-delete-cancel">Keep receipt</AlertDialogCancel>
          <AlertDialogAction onClick={confirm} disabled={busy} className="bg-red-600 hover:bg-red-700" data-testid="receipt-delete-confirm">
            {busy ? 'Deleting…' : 'Delete receipt'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
